import React from "react";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";

export const WithAuthentication : React.FunctionComponent<{children: React.ReactNode}> = ({children }) => {

  if (!navigator.onLine) {
    return <>{children}</>;
  }
  
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );

};
